<template>
  <div class="dialog_school">
    <el-dialog
      :visible.sync="showChangeSchool"
      show-close
      class="dialog_school_content"
      width="450px"
      title="修改学校信息"
      v-if="showChangeSchool"
      :close-on-click-modal="false"
    >
      <template slot="title">
        <div style="text-align: center" class="dialog-title">
          <i class="el-icon-back" @click="$emit('input', false)"></i>
          <span>修改学校信息</span>
        </div>
      </template>
      <el-form
        class="form"
        label-width="0"
        :model="schoolForm"
        :rules="schoolFormRules"
        ref="schoolForm"
      >
        <el-form-item label="" prop="area" class="dialog_school_item">
          <area-cascader-async
            v-model="schoolForm.area"
            placeholder="请选择省/市/区"
            style="width: 100%"
            @handleChange="areaListChange"
          />
        </el-form-item>
        <el-form-item label="" prop="schoolId" class="dialog_school_item">
          <el-select
            v-model.trim="schoolForm.schoolId"
            :placeholder="schoolFilterString ? schoolFilterString : '请选择学校'"
            filterable
            remote
            size="mini"
            :remote-method="handleSchoolRemote"
            :popper-append-to-body="false"
            @change="schoolChange"
            style="width: 100%"
          >
            <el-option-group
              v-for="(group, groupIndex) in schoolGroupList"
              :key="groupIndex"
              :label="group.label"
            >
              <el-option
                v-for="(item, optionIndex) in group.options"
                :key="optionIndex"
                :label="item.schoolName"
                :value="item.schoolId"
              >
                <div class="school-list">
                  <p
                    class="school-list-content"
                    v-html="schoolNameFilter(item.schoolName, schoolFilterString)"
                  ></p>
                  <p v-if="group.type === 'recommand'" class="school-list-district">
                    {{ item.district }}
                  </p>
                </div>
              </el-option>
              <!-- 加载更多 -->
              <div
                class="school-list-loadmore"
                v-if="group.type === 'normal'"
                :style="schoolListPage.state === 'more' ? 'cursor: pointer;' : 'cursor: default;'"
              >
                <p
                  @click="
                    $store.dispatch('GetRegisterSchool', [...form.cityList, schoolFilterString])
                  "
                >
                  {{ schoolListPage.state | pageStateFilter }}
                </p>
              </div>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item
          class="dialog_school_item"
          label=""
          style="cursor: pointer; text-align: right; color: #00c4aa"
        >
          <span
            @click="
              showAddModal = true
              schoolForm.grade = []
            "
            >找不到学校？</span
          >
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button class="dialog_school_close" @click="$emit('input', false)">取消</el-button>
        <el-button class="dialog_school_submit" type="primary" @click="handleSaveSchool"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <!-- 添加手动学校 -->
    <el-dialog
      v-if="showAddModal"
      class="dialog_school_content"
      title="添加学校"
      :visible.sync="showAddModal"
      :close-on-click-modal="false"
      width="450px"
      @close="closeAddModal"
    >
      <template slot="title">
        <div style="text-align: center" class="dialog-title">
          <i
            class="el-icon-back"
            @click="
              showAddModal = false
              schoolForm.addName = ''
              schoolForm.grade = []
            "
          ></i>
          <span>添加学校</span>
        </div>
      </template>
      <el-form
        class="form"
        :model="schoolForm"
        :rules="schoolFormRules"
        ref="addform"
        label-width="0"
      >
        <el-form-item label="" prop="area" class="dialog_school_item">
          <area-cascader-async
            v-model="schoolForm.area"
            :placeholder="'请选择省/市/区'"
            style="width: 100%"
            @handleChange="areaListChange"
          />
        </el-form-item>
        <el-form-item label="" prop="addName" class="dialog_school_item">
          <el-input
            v-model.trim="schoolForm.addName"
            placeholder="请输入学校全称"
            @input="handleUnitNameInput"
          ></el-input>
        </el-form-item>
        <el-form-item class="dialog_school_item" label="" prop="grade">
          <el-select
            v-model="schoolForm.grade"
            placeholder="请选择学段"
            multiple
            style="width: 100%"
          >
            <el-option
              v-for="item in schoolSectionList"
              :key="item.grade"
              :label="item.desc"
              :value="item.grade"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button class="dialog_school_submit" type="primary" @click="handleAddSchool" size="mini"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AreaCascaderAsync from '@/components/AreaCascaderAsync'
import { debounce } from 'lodash'
import { mapState } from 'vuex'
const validateArea = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请选择省/市/区'))
  } else if (value.length !== 3) {
    return callback(new Error('请选择省/市/区'))
  } else {
    callback()
  }
}

const validateAddName = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入学校全称'))
  } else if (!/^[\u2E80-\uFE4Fa-zA-Z0-9()（）]{1,50}$/.test(value)) {
    return callback(new Error('仅允许输入1-50个汉字、数字、字母和括号'))
  } else {
    callback()
  }
}

export default {
  props: {
    value: Boolean
  },

  components: {
    AreaCascaderAsync
  },

  data() {
    return {
      options: [],
      schoolForm: {
        area: [],
        schoolId: '',
        schoolName: '',
        addName: '',
        addNameLoading: false,
        addNameExist: false,
        grade: []
      },
      schoolListPage: {
        current: 0,
        size: 20,
        lotal: 0,
        state: 'more'
      },
      schoolList: [],
      recommandSchoolList: [],
      schoolFilterString: '',
      showAddModal: false
    }
  },

  computed: {
    ...mapState(['teacherRegister']),
    showChangeSchool: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },

    schoolFormRules() {
      return this.showAddModal
        ? {
          area: [{ required: true, validator: validateArea, trigger: 'change' }],
          addName: [{ required: true, validator: validateAddName, trigger: 'blur' }],
          grade: [{ required: true, message: '请选择学段', trigger: 'change' }]
        }
        : {
          area: [{ required: true, validator: validateArea, trigger: 'change' }],
          schoolId: [{ required: true, message: '请选择学校', trigger: 'change' }]
        }
    },

    schoolGroupList() {
      return this.recommandSchoolList.length
        ? [
          {
            type: 'normal',
            label: '',
            options: this.schoolList // 辑时候，默认选项带到页面
          },
          {
            type: 'recommand',
            label: '您选择的学校可能为以下结果',
            options: this.recommandSchoolList
          }
        ]
        : [
          {
            type: 'normal',
            label: '',
            options: this.schoolList // 编辑时候，默认选项带到页面
          }
        ]
    },

    schoolSectionList() {
      return this.teacherRegister.gradeList
    }
  },

  filters: {
    pageStateFilter(val) {
      switch (val) {
        case 'more':
          return '点击加载更多'
        case 'loading':
          return '加载中...'
        case 'finish':
          return '无更多数据'
      }
    }
  },

  methods: {
    areaListChange(val) {
      this.schoolList = []
      this.recommandSchoolList = []
      this.resetSchoolListPage()
      this.schoolForm.schoolId = ''
      this.schoolForm.schoolName = ''
      this.getSchoolList()
    },
    // 关闭添加学校模态框
    closeAddModal() {
      this.schoolForm.addName = ''
      this.schoolForm.grade = []
      this.$emit('input', false)
    },
    /**
     * 分页查询学校数据
     * @description 2020.7.8学校库版本
     */
    getSchoolList() {
      this.$refs.schoolForm.validateField('area', async (validate) => {
        if (validate) return
        if (this.schoolForm.area.length !== 3) return
        if (this.schoolListPage.state === 'finish') return
        // 重置分页
        this.schoolListPage.state = 'loading'
        this.$set(this.schoolListPage, 'current', this.schoolListPage.current + 1)
        const { data } = await API.get('/edu/zone/school/open/query', {
          countryId: '156',
          provinceId: this.schoolForm.area[0],
          cityId: this.schoolForm.area[1],
          districtId: this.schoolForm.area[2],
          page: this.schoolListPage.current,
          limit: this.schoolListPage.size,
          schoolName: this.schoolFilterString
        })
        this.schoolList = [...this.schoolList, ...data.items]
        // 判断长度是否可继续加载
        if (this.schoolList.length < data.total) {
          this.schoolListPage.state = 'more'
        } else {
          this.schoolListPage.state = 'finish'
          // 给出推荐学校
          this.$nextTick(() => {
            this.getRecommandSchoolList()
          })
        }
      })
    },

    /**
     * 异步搜索推荐市级学校
     * @description 2020.7.8学校库版本
     * @description 数据不用于其他业务，暂不放在store里，默认10条数据
     */
    async getRecommandSchoolList() {
      if (!this.schoolFilterString) return
      const { data } = await API.get('/edu/zone/school/open/city/query', {
        districtId: this.schoolForm.area[2],
        schoolName: this.schoolFilterString,
        page: 1,
        limit: 10
      })
      this.recommandSchoolList = data.items
    },

    /**
     * 重置分页
     * @description 不传默认全部重置
     * @description 2020.7.8学校库版本
     */
    resetSchoolListPage(key, value) {
      if (key) {
        this.$set(this.schoolListPage, key, value)
      } else {
        this.schoolListPage = {
          current: 0,
          size: 20,
          lotal: 0,
          state: 'more'
        }
      }
    },

    /**
     * select搜索条件触发
     * @description 若使用watch，地区改变，数据可能未触发变化
     * @description 2020.7.8学校库版本
     */
    handleSchoolRemote(val) {
      this.schoolFilterString = val
      this.resetSchoolListPage()
      this.schoolList = []
      this.recommandSchoolList = []
      if (val.length) {
        this.getSchoolList()
      }
    },

    /**
     * 选择学校下拉框
     * @description 2020.7.8学校库版本
     */
    schoolChange(val) {
      const schoolListTarget = this.schoolList.find((row) => row.schoolId === val)
      const recommandListTarget = this.recommandSchoolList.find((row) => row.schoolId === val)
      if (schoolListTarget) {
        this.schoolForm.schoolName = schoolListTarget.schoolName
        // 重置地区
        this.schoolForm.area = [
          schoolListTarget.provinceId,
          schoolListTarget.cityId,
          schoolListTarget.districtId
        ]
        this.schoolForm.grade = schoolListTarget.grade.split(',')
      } else if (recommandListTarget) {
        this.schoolForm.schoolName = recommandListTarget.schoolName
        // 重置地区
        this.schoolForm.area = [
          recommandListTarget.provinceId,
          recommandListTarget.cityId,
          recommandListTarget.districtId
        ]
        this.schoolForm.grade = recommandListTarget.grade.split(',')
      }
    },

    /**
     * 保存学校信息
     */
    handleSaveSchool() {
      this.$refs.schoolForm.validate(async (valid) => {
        if (!valid) return
        const { status } = await API.post('/edu/zone/school/change', {
          provinceId: this.schoolForm.area[0],
          cityId: this.schoolForm.area[1],
          districtId: this.schoolForm.area[2],
          grades: this.schoolForm.grade,
          schoolId: this.schoolForm.schoolId,
          schoolName: this.schoolForm.schoolName
        })
        if (status === 200) {
          this.$message.success('您添加的学校信息已提交，请耐心等待审核')
          this.$store.dispatch('getSchoolInfo')
          this.$emit('on-succsss')
          this.showAddModal = false
        }
      })
    },

    /**
     * 精准校验添加的学校是否已经存在
     */
    handleUnitNameInput: debounce(function (val) {
      if (!val) return
      this.schoolForm.addNameExist = false
      this.$refs.addform.validateField('area', async (err) => {
        if (err) return
        this.$refs.addform.validateField('addName', async (nameErr) => {
          if (nameErr) return
          this.schoolForm.addNameLoading = true
          const queryString = `countryId=156&provinceId=${this.schoolForm.area[0]}&cityId=${this.schoolForm.area[1]}&districtId=${this.schoolForm.area[2]}&schoolName=${val}`
          const { data } = await API.get(`/edu/zone/school/open/search/one?${queryString}`)
          this.schoolForm.addNameLoading = false
          if (data) {
            this.schoolForm.addNameExist = true
          } else {
            this.schoolForm.addNameExist = false
          }
        })
      })
    }, 500),

    /**
     * 添加自定义学校
     */
    handleAddSchool() {
      if (this.schoolForm.addNameExist) {
        this.$message.error('该学校已存在')
        return
      }

      this.$refs.addform.validate(async (valid) => {
        if (!valid) return
        if (this.schoolForm.addNameLoading) {
          this.$message.warning('正在校验学校名称是否可用')
          return
        }
        const { status } = await API.post('/edu/zone/school/change', {
          provinceId: this.schoolForm.area[0],
          cityId: this.schoolForm.area[1],
          districtId: this.schoolForm.area[2],
          grades: this.schoolForm.grade,
          schoolName: this.schoolForm.addName
        })
        if (status === 200) {
          this.$message.success('您添加的学校信息已提交，请耐心等待审核')
          this.$store.dispatch('getSchoolInfo')
          this.$emit('on-succsss')
          this.showAddModal = false
        }
      })
    },

    /**
     * mark关键字
     * @description 2020.7.8学校库版本
     */
    schoolNameFilter(val, target) {
      let res = val
      target = target.split(/[</mark>]+/).join('')
      if (target === '') {
        return res
      }

      if (val.indexOf(target) > -1) {
        return res.split(target).join(`<mark>${target}</mark>`)
      }

      const tl = target.length

      for (let cadence = tl; cadence > 1; cadence -= 1) {
        for (let i = 0; i <= tl - cadence; i += 1) {
          const tsub = target.substring(i, i + cadence)
          res = res.split(tsub).join(`<mark>${tsub}</mark>`)
        }
      }

      if (tl <= 2) {
        for (let i = 0; i < tl; i++) {
          res = res.split(target[i]).join(`<mark>${target[i]}</mark>`)
        }
      } else if (tl <= 8) {
        const suffix = target[tl - 1]
        res = res.split(suffix).join(`<mark>${suffix}</mark>`)
      }

      return res
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-title {
  display: flex;
  i {
    cursor: pointer;
  }
  span {
    flex: 1;
  }
}
.school-list {
  .school-list-district {
    color: #cdcdcd;
  }
}
.school-list-loadmore {
  text-align: center;
  color: #999;
  font-size: 12px;
  line-height: 34px;
}
/deep/ .el-select-group .el-select-dropdown__item {
  min-height: 34px;
  height: fit-content;
}
/deep/ mark {
  color: var(--primary-el-color);
  background: #fff;
}
.foot {
  margin-top: 30px;
  width: 100%;
  text-align: center;
}
.form {
  margin: 0 auto;
}
/deep/ .count-down-btn {
  width: 100%;
}
.dialog_school {
  position: absolute;
  right: -105px;
  top: 0px;
  .dialog_school_btn {
    color: #00c4aa;
    font-size: 12px;
  }
  .dialog_school_tip {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
    margin-bottom: 16px;
    text-align: center;
  }
  .dialog_school_content {
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
    /deep/ .el-dialog__header {
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 22px;
    }
    /deep/ .el-cascader__label {
      line-height: 39px;
    }
    /deep/ .el-input__inner {
      height: 39px;
      line-height: 39px;
    }
    .footer {
      margin-top: 80px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .dialog_school_item {
      line-height: 39px;
      padding: 0 25px 2px;
    }
    .dialog_school_submit {
      width: 88px;
      height: 32px;
      background-color: #ffa21c;
      border: 1px solid #ffa21c;
      color: #fff;
      border-radius: 4px;
      &:hover {
        opacity: 0.7;
      }
    }
    .dialog_school_close {
      width: 88px;
      height: 32px;
    }
  }
}
</style>
